// extracted by mini-css-extract-plugin
export default {"titleRow":"e3s3lThQWd6TGnoqcVd5","formBox":"ZLpBI6LnMgnjM_xAp1VO"};